import Form from "JS/form/Form";
import { lockScroll, unlockScroll } from 'JS/utils/lock-screen';
import { notice } from "JS/utils/notice";

class addressController {
    constructor(addressModal) {
        if (!addressModal) {
            return;
        }

        this.formElm = document.querySelector('.account-address-modal__wrap-form');
        this.formObj = new Form(this.formElm);

        this.addressModal = addressModal;
        this.delModal = document.querySelector('.account-delete-address');

        this.addressesContainer = document.querySelector('.account-address__items');

        this.closeBtns = document.querySelectorAll('[data-close-modal]');
        this.addBtn = document.querySelector('.account-address__add');
        this.saveBtn = document.querySelector('.account-address__save');
        this.delBtn = document.querySelector('.account-address__del');
        this.inputNonce = document.querySelector('#addresses_nonce');

        this.addressFields = ['City', 'Address_1', 'Address_2'];

        this.addressFields.forEach(field => {
            this[`input${field}`] = document.querySelector(`input[name="billing_${field.toLowerCase()}"]`);
        });

        this.cityData = null;

        this.init();
        this.initAddressItemBtns();
    }

    init() {
        this.closeBtns.forEach(element => {
            element.addEventListener('click', () => {
                this.close(this.delModal);
                this.close(this.addressModal);
            });
        });

        this.formObj.on('submit', (data) => {
            this._requestSaveAddress(data);
        });

        this.inputCity.readOnly = true;
        this.inputCity.setAttribute('autocomplete', 'off');

        this.listCitiesContainer = document.createElement('div');
        this.listCitiesContainer.classList.add('cities-list-wrapper');

        this.inputCityContainer = this.inputCity.parentNode.parentNode;
        this.inputCityContainer.appendChild(this.listCitiesContainer);
        this.inputCityContainer.classList.add('input-wrap--billing-city');

        this.inputCityContainer.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.showCitiesList();
        });

        document.addEventListener('click', (e) => {
            if (!e.target.closest('input-wrap--billing-city')) {
                this.hideCitiesList();
            }
        });

        this.listCitiesContainer.innerHTML += `
        <div class="input-wrap">
            <label class="form-input-type-text form-input form-input--search-city" data-input-type="text">
                <input name="search_city" placeholder="поиск города" type="text" value="" class="search-city">
            </label>
        </div>`;

        this.inputSearch = this.listCitiesContainer.querySelector('.search-city');
        this.inputSearch.setAttribute('autocomplete', 'off');

        let timeOut;
        this.inputSearch.addEventListener('input', (e) => {
            if (timeOut) {
                clearTimeout(timeOut);
            }

            timeOut = setTimeout(() => {
                this.requestCities(e.target.value);
            }, 500);

        });

        this.searchLabelCity = this.listCitiesContainer.querySelector('.form-input--search-city');

        this.listCities = document.createElement('ul');
        this.listCities.classList.add('cities-list');
        this.listCitiesContainer.appendChild(this.listCities);
        this.listCities.addEventListener('click', this.clickCitiesList);

        this.addBtn.addEventListener('click', this._addAddress);
        this.delBtn.addEventListener('click', this._requestDelAddress);
    }


    initAddressItemBtns() {
        this.editBtns = document.querySelectorAll('.account-address__item-control--edit');
        this.editBtns.forEach(element => element.addEventListener('click', this._editAddress));

        this.delBtns = document.querySelectorAll('.account-address__item-control--delete');
        this.delBtns.forEach(element => element.addEventListener('click', this._delAddress));
    }

    showCitiesList() {
        this.listCitiesContainer.classList.add('active');
        this.inputSearch.value = '';
    }

    hideCitiesList() {
        this.listCitiesContainer.classList.remove('active', 'scroll');
        this.listCities.innerHTML = '';
    }

    _addAddress = (e) => {
        this.formElm.querySelectorAll('.form-input').forEach(elm => { elm.classList.remove('error') });
        this.formElm.querySelectorAll('.error-element').forEach(elm => { elm.classList.remove('show') });
        this.saveBtn.setAttribute('data-action-type', 'save');
        this.open(this.addressModal);
    }

    _editAddress = (e) => {
        const btn = e.target.closest('.account-address__item-control--edit');
        const key = btn.getAttribute('data-key');

        this.saveBtn.setAttribute('data-action-type', 'update');
        this.saveBtn.setAttribute('data-key', key);

        let inputEvent = new Event('input', {
            bubbles: true,
        });

        this.addressFields.forEach(field => {
            this[`input${field}`].value = btn.getAttribute(field);
            this[`input${field}`].dispatchEvent(inputEvent);
        });

        this.cityData = JSON.parse(btn.getAttribute('city-data'));

        this.open(this.addressModal);
    }

    _delAddress = (e) => {
        const btn = e.target.closest('.account-address__item-control--delete');
        const key = btn.getAttribute('data-key');
        this.delBtn.setAttribute('data-key', key);
        this.open(this.delModal);
    }

    requestCities(city) {
        this.searchLabelCity.classList.add('proccessing');

        this.listCities.innerHTML = '';
        this.listCitiesContainer.classList.remove('scroll');

        const formData = new FormData();

        formData.append('action', 'edostavka_get_location_cities');
        formData.append('city', city);
        formData.append('country_codes', 'RU');
        formData.append('size', 10);

        fetch(backendData.ajaxUrl, {
            method: 'POST',
            body: formData,
        })
            .then(resp => resp.json())
            .then(response => {
                const {
                    data,
                    success,
                } = response;

                if (data.length > 0) {
                    data.forEach((item) => {
                        if (item.code) {
                            const new_elm = document.createElement('li');
                            new_elm.classList.add('cities-list__item');
                            new_elm.setAttribute('data-city', JSON.stringify(item));
                            new_elm.innerHTML = `${item.city}, ${item.region}, ${item.sub_region}`;

                            new_elm.addEventListener('click', this.clickListCity);
                            this.listCities.appendChild(new_elm);
                        }
                    })
                    if (data.length > 5) {
                        this.listCitiesContainer.classList.add('scroll');
                    } else {
                        this.listCitiesContainer.classList.remove('scroll');
                    }

                    this.searchLabelCity.classList.remove('proccessing');

                } else {
                    this.searchLabelCity.classList.remove('proccessing');
                }

            })
            .catch(error => {
                this.searchLabelCity.classList.remove('proccessing');
                notice(error, 'error');
            })
    }

    clickListCity = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const city_data = JSON.parse(e.target.getAttribute('data-city'));
        const location = {
            '_resultId': city_data.code,
            'id': city_data.city,
            'text': city_data.city,
            'title': `${city_data.country}, ${city_data.region}, ${city_data.city}`,
            'code': city_data.code,
            'region': city_data.region,
            'region_code': city_data.region_code,
            'sub_region': city_data.sub_region,
            'country': city_data.country,
            'country_code': city_data.country_code,
            'longitude': city_data.longitude,
            'latitude': city_data.latitude,
            'selected': true,
        };
        let inputEvent = new Event('input', {
            bubbles: true,
        });
        this.inputCity.value = city_data.city;
        this.inputCity.dispatchEvent(inputEvent);

        this.cityData = location;

        this.hideCitiesList();
    }

    _requestSaveAddress(data) {
        this.saveBtn.classList.add('processing');
        const action_type = this.saveBtn.getAttribute('data-action-type');

        const ajax_action = `hml_user_${action_type}_address`;
        const formData = new FormData();

        Object.keys(data).forEach(el => {
            formData.append(el, data[el]);
        });

        if (action_type == 'update') {
            formData.append('key', this.saveBtn.getAttribute('data-key'));
        }

        formData.append('billing_country', this.cityData.country_code);
        formData.append('billing_state', this.cityData.region);
        formData.append('action', ajax_action);
        formData.append('billing_cdek_addr_data', JSON.stringify(this.cityData));
        formData.append('action', ajax_action);

        fetch(backendData.ajaxUrl, {
            method: 'POST',
            body: formData,
        })
            .then(resp => resp.json())
            .then(response => {
                const {
                    data,
                    success,
                } = response;

                if (success) {
                    this.addressesContainer.innerHTML = data.addresses_html;
                    this.initAddressItemBtns();
                    this.close(this.addressModal);
                } else {
                    notice(data.message, 'error');
                }

            })
            .catch(error => {
                notice(error, 'error');
            })
            .finally(() => {
                this.saveBtn.classList.remove('processing');
            })
    }

    _requestDelAddress = (e) => {
        e.preventDefault();
        this.delBtn.classList.add('processing');
        
        const formData = new FormData();

        formData.append('key', this.delBtn.getAttribute('data-key'));
        formData.append('action', 'hml_user_del_address');
        formData.append('addresses_nonce', this.inputNonce.value);

        fetch(backendData.ajaxUrl, {
            method: 'POST',
            body: formData,
        })
            .then(resp => resp.json())
            .then(response => {
                const {
                    data,
                    success,
                } = response;

                if (success) {
                    this.addressesContainer.innerHTML = data.addresses_html;
                    this.initAddressItemBtns();
                    this.close(this.delModal);
                } else {
                    notice(data.message, 'error');
                }

            })
            .catch(error => {
                notice(error, 'error');
            })
            .finally(() => {
                this.delBtn.classList.remove('processing');
            })
    }

    open(modal) {
        modal.classList.add('modal-open');
        lockScroll();
    }

    close(modal) {
        modal.classList.remove('modal-open');
        unlockScroll();
        if (modal.classList.contains('account-address-modal')) {
            setTimeout(() => {
                let inputEvent = new Event('input', {
                    bubbles: true,
                });
                this.addressFields.forEach(field => {
                    this[`input${field}`].value = '';
                    this[`input${field}`].dispatchEvent(inputEvent);
                });
            }, 200);
        }
    }
}

(() => {
    const addressModal = document.querySelector('.account-address-modal');
    if (addressModal) {
        new addressController(addressModal);
    }
})();
